import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70af158c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "body"
}
const _hoisted_4 = {
  key: 1,
  class: "footer"
}

import { computed, PropType, ref, useSlots } from "vue";
import { Dialog as KDialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { modalTypes, sizes, actionLayout } from "./modalTypes";
import IbIcons from "@/components/icons/ib-icons.vue";

// emits

export default /*#__PURE__*/_defineComponent({
  __name: 'IDialog',
  props: {
  title: {
    type: String,
  },
  type: {
    type: String as PropType<modalTypes>,
  },
  size: {
    default: String as PropType<sizes>,
  },
  actionsLayout: {
    type: String as PropType<actionLayout>,
    default: actionLayout.END,
  },
},
  emits: ["close", "confirm"],
  setup(__props, { emit }) {

const props = __props;



// props


// refs
const header = ref("header");

// slots
const slots = useSlots();

// computed
const icon = computed(() => {
  switch (props.type) {
    case modalTypes.WARNING:
      return "exclamation_mark_yellow_triangle";
    case modalTypes.ALERT:
      return "exclamation_mark_red_circle";
    case modalTypes.ERROR:
      return "x_red_circle";
    case modalTypes.SUCCESS:
      return "v_green_circle";
    default:
      return "";
  }
});

// methods
const closeModal = (): void => {
  emit("close");
};

const confirmModal = (): void => {
  emit("confirm");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KDialog), {
    onClose: closeModal,
    "title-render": __props.title ? header.value : null,
    appendTo: "body",
    className: "ib-dialog"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.type)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(IbIcons, { icon: _unref(icon) }, null, 8, ["icon"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(__props.title), 1)
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_unref(slots).body)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "body")
          ]))
        : _createCommentVNode("", true),
      (_unref(slots).footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(DialogActionsBar), {
              layout: __props.actionsLayout,
              buttonGroupClass: false
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "footer")
              ]),
              _: 3
            }, 8, ["layout"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["title-render"]))
}
}

})